// =============================================================================
// File: searchai-session-client.js
// =============================================================================

// Define the global namespace early (Legacy Access Point)
window.SearchAI = window.SearchAI || {};


// ================================
// Session Module
// ================================

// Define the core methods for the Session module
const SESSION_KEY = 'searchai_session_id';
const EXPIRATION_MINUTES = 1440; // expires after 1 day

/**
 * Creates a new, unique session object.
 */
function createNewSession() {
  return {
    id: 'sess_' + Math.random().toString(36).substring(2) + Date.now(),
    created_at: Date.now()
  };
}

/**
 * Retrieves the current valid Session ID from localStorage, refreshing if expired.
 * @returns {string} The current session ID.
 */
// Added 'export' for module compatibility
export function getSessionId() { 
  let sessionData = localStorage.getItem(SESSION_KEY);
  let sessionObj;

  if (sessionData) {
    sessionObj = JSON.parse(sessionData);
    const ageMinutes = (Date.now() - sessionObj.created_at) / (1000 * 60);
    
    // Check if expired
    if (ageMinutes > EXPIRATION_MINUTES) {
        // expires after 1 day
        sessionObj = createNewSession();
    }
  } else {
    // If no session is found, create a new one.
    sessionObj = createNewSession();
  }

  localStorage.setItem(SESSION_KEY, JSON.stringify(sessionObj));
  return sessionObj.id;
}


// ================================
// Client Module (Refactored Core)
// ================================
const CLIENT_KEY = 'search-ai-client-id';

/**
 * Retrieves a persistent, unique Client ID from localStorage, creating one if it doesn't exist.
 * @returns {string} The current client ID.
 */
// Added 'export' for module compatibility
export function getClientId() { 
  let id = localStorage.getItem(CLIENT_KEY);
  if (!id) {
    // If no client ID exists, generate a new one and store it.
    id = 'client_' + Math.random().toString(36).substring(2) + Date.now();
    localStorage.setItem(CLIENT_KEY, id);
  }
  return id;
}

window.SearchAI.Session = {
    // Expose the exported function for global access
    getSessionId: getSessionId 
};

// Client Module Exposure (Mocking the old SearchAI.Client return)
window.SearchAI.Client = {
    // Expose the exported function for global access
    getClientId: getClientId
};